import RestApiCall from "interceptor/aeh";
import Environment from "services/environment";

const env = Environment.getEnv();

export const logoutUser = (payload) => {
  const apiPayload = {
    method: "POST",
    url: "/user/v1/user/logout",
    baseURL: env.profileBaseUrl,
    data: payload,
    config: {
      ignoreError: true,
      ignoreBusinessError: true,
    },
  };
  return RestApiCall.api(apiPayload);
};
